<template>
  <div id="lightingSetting">
    <div class="top">
      <p v-wave class="tabName" :class="item.status ? 'tabNameActive' : ''" v-for="item in tabList" :key="item.value" @click="tabChange(item)">
        {{$t(item.name)}}
      </p>
    </div>
    <div class="bottom">
      <div class="left">
        <div class="fastSelect">
          <h4>{{ $t('快速选择') }}</h4>
          <el-button-group>
            <el-button v-wave type="primary" @click="fastSelect('1')">{{ $t('全选') }}</el-button>
            <el-button v-wave type="primary" @click="fastSelect('2')">WASD</el-button>
            <el-button v-wave type="primary" @click="fastSelect('3')">{{ $t('数字') }}</el-button>
            <el-button v-wave type="primary" @click="fastSelect('4')">A - Z</el-button>
            <el-button v-wave type="primary" @click="fastSelect('5')">{{ $t('反选') }}</el-button>
            <el-button v-wave type="primary" @click="fastSelect('6')">{{ $t('取消') }}</el-button>
          </el-button-group>
        </div>
        <div class="sliderBox">
          <div class="switch">
            <h4>{{ $t('灯光开关') }}
              <el-popover
                placement="right"
                :title="$t('说明')"
                width="350"
                trigger="hover">
                <div>
                  <p style="line-height: 0.25rem">
                    {{$t('提示内容62')}}
                  </p>
                </div>
                <i slot="reference" class="el-icon-info" style="color: #FF9A00;font-size: 0.2rem;"></i>
              </el-popover>
            </h4>
            <el-switch v-model="jointLightSetting.openLight" inactive-color="#888888" @change="openLightChange"></el-switch>
          </div>
        </div>
        <div class="sliderBox">
          <div class="slider">
            <h4>{{ $t('灯光亮度') }}
              <el-popover
                placement="right"
                :title="$t('说明')"
                width="350"
                trigger="hover">
                <div>
                  <p style="line-height: 0.25rem">
                    {{$t('提示内容63')}}
                  </p>
                </div>
                <i slot="reference" class="el-icon-info" style="color: #FF9A00;font-size: 0.2rem;"></i>
              </el-popover>
            </h4>
            <el-slider show-input v-model="jointLightSetting.luminance" :min="0" :max="30" :step="1" @change="luminanceChange"></el-slider>
          </div>
        </div>
        <div class="sliderBox">
          <div class="switch">
            <h4>{{ $t('开启Fn层灯光') }}</h4>
            <el-switch v-model="jointLightSetting.openFnLight" inactive-color="#888888" @change="FnRgbSwitchChange"></el-switch>
          </div>
        </div>
        <div class="sliderBox">
          <div class="switch">
            <h4>{{ $t('开启Win键锁灯光') }}</h4>
            <el-switch v-model="jointLightSetting.openWinLight" inactive-color="#888888" @change="WinLockSwitchChange"></el-switch>
          </div>
        </div>
        <div class="sliderBox">
          <div class="switch">
            <h4>{{ $t('开启Cap键灯光') }}</h4>
            <el-switch v-model="jointLightSetting.openCapLight" inactive-color="#888888" @change="CapsSwitchChange"></el-switch>
          </div>
        </div>
        <div class="sliderBox">
          <div class="switch">
            <h4>{{ $t('休眠时间') }}</h4>
            <el-select size="mini" v-model="jointLightSetting.sleepTime" @change="sleepTimeChange">
              <el-option
                  v-for="item in sleepTimeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="sliderBox">
          <el-button type="primary" @click="openDia()">{{ $t('导入与导出') }}<i class="el-icon-sort el-icon--right"></i></el-button>
        </div>
      </div>
      <el-divider direction="vertical"></el-divider>
      <div class="right">
        <div v-show="tabList[0].status" class="sliderBox">
          <div class="pickerBox">
            <h4>{{ $t('灯光颜色') }}</h4>
            <div style="display: flex">
              <div id="picker" style="margin: 0.2rem"></div>
              <div style="margin-top: 0.2rem;">
                <p style="margin-bottom: 0.1rem;margin-right: 0.1rem;text-align: center">
                  <label style="margin-right: 0.1rem">R</label><el-input :max="255" :min="0" :step="1" type="text" size="mini" v-model="color.r" @input="rbgInput"/>
                </p>
                <p style="margin-bottom: 0.1rem;margin-right: 0.1rem;text-align: center">
                  <label style="margin-right: 0.1rem">G</label><el-input :max="255" :min="0" :step="1"  type="text" size="mini" v-model="color.g" @input="rbgInput"/>
                </p>
                <p style="margin-bottom: 0.1rem;margin-right: 0.1rem;text-align: center">
                  <label style="margin-right: 0.1rem">B</label><el-input :max="255" :min="0" :step="1" type="text" size="mini" v-model="color.b" @input="rbgInput"/>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div v-show="tabList[1].status" class="sliderBox">
          <div class="selectBox">
            <h4>{{ $t('动态灯效选择') }}
              <el-popover
                placement="right"
                :title="$t('说明')"
                width="350"
                trigger="hover">
                <div>
                  <p style="line-height: 0.25rem">
                    {{$t('提示内容64')}}
                  </p>
                </div>
                <i slot="reference" class="el-icon-info" style="color: #FF9A00;font-size: 0.2rem;"></i>
              </el-popover>
            </h4>
            <el-select v-model="dynamicLightSetting.dynamicMode">
              <el-option
                  v-for="item in dynamicModeList"
                  :key="item.value"
                  :label="$t('模式') + ' - ' + item.name"
                  :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="slider">
            <h4>{{ $t('动态灯效H值') }}</h4>
            <el-slider :show-input-controls="false" show-input v-model="dynamicLightSetting.H" :min="0" :max="255" :step="1"></el-slider>
          </div>
          <div class="slider">
            <h4>{{ $t('动态灯效S值') }}</h4>
            <el-slider :show-input-controls="false" show-input v-model="dynamicLightSetting.S" :min="0" :max="255" :step="1"></el-slider>
          </div>
          <div class="slider">
            <h4>{{ $t('动态灯效速度') }}
              <el-popover
                placement="right"
                :title="$t('说明')"
                width="350"
                trigger="hover">
                <div>
                  <p style="line-height: 0.25rem">
                    {{$t('提示内容65')}}
                  </p>
                </div>
                <i slot="reference" class="el-icon-info" style="color: #FF9A00;font-size: 0.2rem;"></i>
              </el-popover>
            </h4>
            <el-slider :show-input-controls="false" show-input v-model="dynamicLightSetting.speed" :min="0" :max="255" :step="1"></el-slider>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :title="$t('灯光共享')"
      :visible.sync="centerDialogVisible"
      width="30%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      :append-to-body="true">
      <div class="lightBox">
        <div class="exportAndImport">
          <h5>{{ $t('导出灯光配置') }}</h5>
          <el-button v-wave @click="exportToJson">{{ $t('导出') }}</el-button>
        </div>
        <div class="exportAndImport">
          <h5>{{ $t('导入灯光配置') }}</h5>
          <el-button v-wave @click="triggerFileInput('0')">{{ $t('导入') }}</el-button>
          <p v-show="fileName"><span>File：</span>{{fileName}}</p>
          <input class="import" type="file" @change="handleFileUpload($event)" accept=".json" ref="fileInput"/>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="centerDialogVisible = false">{{ $t('取消') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import iro from '@jaames/iro';
import {key_zent75_address, lightingPatternArr} from '@/store/state'
import EventBus from '@/store/eventBus'
import {decimalToByteArray, delay} from "@/store/utils";
export default {
  name: "lightingSetting",
  props: {
    HidCmdReadRam: Function
  },
  data() {
    return {
      productName: '',
      fileName: '',
      centerDialogVisible: false,
      isConnected: false, // 键盘连接状态
      addressList: key_zent75_address, // 默认75配列
      tabList:[
        {
          name: '静态灯光',
          value: '1',
          status: true
        },
        {
          name: '动态灯光',
          value: '0',
          status: false
        }
      ],
      tabActive: '1',
      // 共同的灯光设置
      jointLightSetting: {
        openLight: true,
        luminance: 10, // 灯光亮度
        openFnLight: true,
        openWinLight: true,
        openCapLight: true,
        sleepTime: ''
      },
      sleepTimeOptions: [
        {
          label: 'Never',
          value: 0
        },
        {
          label: '1mins',
          value: 60
        },
        {
          label: '2mins',
          value: 120
        },
        {
          label: '3mins',
          value: 180
        },
        {
          label: '5mins',
          value: 300
        },
        {
          label: '10mins',
          value: 600
        },
        {
          label: '15mins',
          value: 900
        },
        {
          label: '20mins',
          value: 1200
        },
        {
          label: '25mins',
          value: 1500
        },
        {
          label: '30mins',
          value: 1800
        }
      ], // 休眠时间选项
      dynamicLightSetting: {
        dynamicMode: 1, // 动态灯效模式
        H: 188,
        S: 255,
        speed: 50
      },
      dynamicModeList: lightingPatternArr,
      color: {
        r: 255,
        g: 0,
        b: 0
      }
    }
  },
  mounted() {
    this.colorPicker = new iro.ColorPicker('#picker',{
      borderWidth: 2,
      color: "#ff0000",
      layout: [
        {
          component: iro.ui.Box,
          options: {
            borderColor:'#ffffff'
          }
        },
        {
          component: iro.ui.Slider,
          options: {
            borderColor:'#ffffff',
            sliderType: 'hue'
          }
        },
      ]
    });
    this.colorPicker.on("color:change", color => {
      // 处理颜色变化事件，color 是所选择的颜色
      this.$set(this,'color',color.rgb)
    });
    EventBus.$on('connected', this.getConnectedResult)
    EventBus.$on('lightingSettingConfirm', this.handleLightingSettingConfirm)
    EventBus.$on('getRgbSwitchData',this.getRgbSwitchData)
    EventBus.$on('getKeyDynamicStateData',this.getKeyDynamicStateData)
    EventBus.$on('getProductName',this.getProductName)
    EventBus.$on('getInitializeResult', (obj) => {
      this.addressList = obj.addressList
    })
  },
  methods: {
    getProductName(val) {
      this.productName = val
    },
    openDia() {
      if (this.isConnected) {
        this.centerDialogVisible = true
      } else {
        this.$notify.info({
          title: this.$t('提示'),
          message: this.$t('提示内容1'),
          offset: 100
        })
      }
    },
    exportToJson() {
      EventBus.$emit('exportToJson')
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file && file.type === "application/json") {
        const reader = new FileReader();
        reader.onload = (e) => {
          try {
            let jsonData = JSON.parse(e.target.result);
            if (jsonData[0].name === this.productName) {
              this.fileName = file.name
              this.sendLightConfig(jsonData)
            } else {
              this.$notify.info({
                title: this.$t('提示'),
                message: this.$t('提示内容10'),
                offset: 100
              })
            }
          } catch (err) {
            console.error("Error parsing JSON: ", err);
          }
        };
        reader.readAsText(file);
      } else {
        this.$notify.info({
          title: this.$t('提示'),
          message: this.$t('提示内容11'),
          offset: 100
        })
      }
      event.target.value = null;
    },
    async sendLightConfig(data) {
      for (const e of data) {
        let arr = Object.values(e.value)
        if (e.name === 'rgb_matrix_settings') {
          // await this.childARef.HidCmdSetRam(this.addressList.rgb.address, arr, e.length)
          this.$emit('set', this.addressList.rgb.address, arr, e.length)
        } else if (e.name === 'rgb_config_settings') {
          // await this.childARef.HidCmdSetRam(this.addressList.rgb_config.address, arr, e.length)
          this.$emit('set', this.addressList.rgb_config.address, arr, e.length)
        }
      }
      await delay()
      const rgbSwitchData = await this.HidCmdReadRam(this.addressList.rgb_config.address,17)
      // 传递键盘灯效数据给RGB组件
      EventBus.$emit('getKeyDynamicStateData',rgbSwitchData.slice(0,5))
      EventBus.$emit('getRgbSwitchData',rgbSwitchData.slice(8,18))
      // 读取按键RGB
      const keyRGBDate = await this.HidCmdReadRam(this.addressList.rgb.address,this.addressList.rgb.length)
      const keyRGBModeDate = await this.HidCmdReadRam(this.addressList.rgb_solid_enable.address,this.addressList.rgb_solid_enable.length)
      // 传递按键RGB数据给键盘组件
      EventBus.$emit('getKeyRGBDate',[...keyRGBDate,...keyRGBModeDate])
      setTimeout(() => {
        this.$notify({
          title: this.$t('成功'),
          message: this.$t('导入成功'),
          type: 'success',
          offset: 100
        })
      },1000)
    },
    // 处理得到的动态灯效数据方法
    getKeyDynamicStateData(val) {
      this.dynamicLightSetting.dynamicMode = (val[0] - 1)/4  // 反显灯光模式的值
      this.dynamicLightSetting.H = val[1] // 反显动态灯光h值
      this.dynamicLightSetting.S = val[2] // 反显动态灯光s值
      this.jointLightSetting.luminance = val[3] // 反显灯光亮度
      this.dynamicLightSetting.speed = val[4] // 反显动态灯光速度
    },
    getRgbSwitchData(arr) {
      this.jointLightSetting.openLight = arr[0] === 1
      this.jointLightSetting.openCapLight = arr[1] === 1
      this.jointLightSetting.openFnLight = arr[3] === 1
      this.jointLightSetting.sleepTime = arr[4] + arr[5] * 256
      this.jointLightSetting.openWinLight = arr[8] === 1
    },
    handleLightingSettingConfirm() {
      EventBus.$emit('lightingSettingReturn',{
        tabActive: this.tabActive,
        jointLightSetting: this.jointLightSetting,
        dynamicLightSetting: this.dynamicLightSetting,
        color: this.color
      })
    },
    // 快速选择
    fastSelect(val) {
      EventBus.$emit('fastSelect',val)
    },
    // 获取键盘连接状态回调
    getConnectedResult(val) {
      this.isConnected = val
    },
    tabChange(obj) {
      this.tabList.forEach(e => {
       if (obj.value === e.value) {
         e.status = true
         this.tabActive = e.value
       } else {
         e.status = false
       }
      })
    },
    rbgInput() {
      this.colorPicker.color.rgb = {
        r: this.color.r,
        g: this.color.g,
        b: this.color.b
      }
    },
    // 灯光开关
    openLightChange() {
      if (this.isConnected) {
        if (this.jointLightSetting.openLight) {
          this.$emit('set', this.addressList.rgb_enable.address, [1], this.addressList.rgb_enable.length);
        } else {
          this.$emit('set', this.addressList.rgb_enable.address, [0], this.addressList.rgb_enable.length);
        }
      }
    },
    // 灯光亮度
    luminanceChange(val) {
      if (val > 10) {
        this.$notify({
          title: this.$t('风险提示'),
          message: this.$t('提示内容12'),
          type: 'warning',
          offset: 100
        })
      }
    },
    async FnRgbSwitchChange() {
      if (this.isConnected) {
        if (this.jointLightSetting.openFnLight) {
          this.$emit('set', this.addressList.rgb_fn_enable.address, [1], this.addressList.rgb_fn_enable.length);
        } else {
          this.$emit('set', this.addressList.rgb_fn_enable.address, [0], this.addressList.rgb_fn_enable.length);
        }
      }
    },
    async WinLockSwitchChange() {
      if (this.isConnected) {
        if (this.jointLightSetting.openWinLight) {
          this.$emit('set', this.addressList.win_lock_state.address, [1], this.addressList.win_lock_state.length);
        } else {
          this.$emit('set', this.addressList.win_lock_state.address, [0], this.addressList.win_lock_state.length);
        }
      }
    },
    async CapsSwitchChange() {
      if (this.isConnected) {
        if (this.jointLightSetting.openCapLight) {
          this.$emit('set', this.addressList.cap_enable.address, [1], this.addressList.cap_enable.length);
        } else {
          this.$emit('set', this.addressList.cap_enable.address, [0], this.addressList.cap_enable.length);
        }
      }
    },
    async sleepTimeChange() {
      if (this.isConnected) {
        if (this.jointLightSetting.sleepTime !== '') {
          let ram = decimalToByteArray(this.jointLightSetting.sleepTime).reverse()
          await this.$emit('set',this.addressList.sleep_second_cnt.address,ram,this.addressList.sleep_second_cnt.length)
          await delay()
          this.$notify({
            title: this.$t('成功'),
            message: this.$t('修改成功'),
            type: 'success',
            offset: 100
          })
        }
      } else {
        this.$notify.info({
          title: this.$t('提示'),
          message: this.$t('提示内容1'),
          offset: 100
        })
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../style/handle.scss';
  #lightingSetting {
    .top {
      display: flex;
      justify-content: center;
      margin-bottom: 0.1rem;
      border-bottom: 0.03rem solid;
      @include border_color('border-bottom-color');
      height: 0.5rem;
      .tabName {
        width: 3rem;
        height: 0.5rem;
        font-weight: 700;
        //line-height: 40px;
        text-align: center;
        margin-right: 0.05rem;
        //box-shadow: 0 5px 12px rgba(0,0,0,0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.15rem;
      }
      .tabNameActive {
        color: #409EFF;
        border-bottom: 0.03rem solid #409EFF;
      }
    }
    .bottom {
      display: flex;
      height: 4.9rem;
      .left {
        width: 50%;
        .fastSelect {
          padding: 0 0.2rem;
          h4 {
            margin-bottom: 0.1rem;
            font-size: 0.15rem;
          }
          .el-button-group {
            .el-button {
              width: 1rem;
              border-width: 0.01rem;
              padding: 0.12rem 0.2rem;
              font-size: 0.14rem;
              border-radius: 0.04rem;
            }
          }
        }
        .sliderBox {
          padding: 0 0.2rem;
          width: 100%;
          margin-top: 0.15rem;
          .switch {
            display: flex;
            justify-content: space-between;
            align-items: center;
            h4 {
              font-size: 0.15rem;
            }
            /deep/.el-switch {
              font-size: 0.14rem !important;
              line-height: 0.2rem !important;
              height: 0.2rem !important;
              .el-switch__label {
                height: 0.2rem;
                font-size: 0.14rem !important;
                span {
                  font-size: 0.14rem !important;
                }
              }
              .el-switch__label--left {
                margin-right: 0.1rem;
              }
              .el-switch__label--right {
                margin-left: 0.1rem;
              }
              .el-switch__core {
                width: 0.4rem !important;
                height: 0.2rem;
                border-radius: 0.1rem;
                border-width: 0.01rem;
              }
              .el-switch__core:after {
                top: 0.01rem;
                left: 0.01rem;
                width: 0.16rem;
                height: 0.16rem;
              }
            }
            /deep/.el-switch.is-checked .el-switch__core::after {
              margin-left: 0.19rem !important;
            }
            ///deep/.el-select>.el-input {
            //  .el-input--mini .el-input__inner {
            //    height: 0.28rem;
            //    line-height: 0.28rem;
            //    padding-right: 0.3rem;
            //    border-radius: 0.04rem;
            //    border-width: 0.01rem;
            //  }
            //}
          }
          .slider {
            h4 {
              font-size: 0.15rem;
            }
          }
        }
        .sliderBox:first-child {
          margin-top: 0.25rem;
        }
      }
      .el-divider--vertical {
        height: 100%;
        background-color: #888888;
      }
      .right {
        width: 50%;
        padding-left: 0.1rem;
        .sliderBox {
          width: 90%;
          .selectBox {
            h4 {
              margin-bottom: 0.1rem;
              font-size: 0.15rem;
            }
          }
          .slider {
            margin-top: 0.2rem;
            h4 {
              font-size: 0.15rem;
            }
          }
        }
        /deep/.pickerBox {
          h4 {
            font-size: 0.15rem;
          }
          //.IroBox {
          //  width: 3rem !important;
          //  height: 3rem !important;
          //  border-radius: 0.14rem !important;
          //  border-width: 0.02rem !important;
          //  //svg {
          //  //  transform: translate(0.14rem,0.176844rem) !important;
          //  //  top: -0.08rem !important;
          //  //  left: -0.08rem !important;
          //  //  width: 0.16rem !important;
          //  //  height: 0.16rem !important;
          //  //}
          //}
          //.IroSlider {
          //  width: 3rem !important;
          //  height: 0.28rem !important;
          //  border-radius: 0.14rem !important;
          //  margin-top: 0.12rem !important;
          //}
        }
      }
    }
    ///deep/.el-dialog {
    //  margin: 0 auto 0.5rem;
    //  border-radius: 0.02rem;
    //  .el-dialog__header {
    //    padding: 0.2rem 0.2rem 0.1rem;
    //    .el-dialog__title {
    //      font-size: 0.18rem;
    //      line-height: 0.24rem;
    //    }
    //    .el-dialog__headerbtn {
    //      top: 0.2rem;
    //      right: 0.2rem;
    //      font-size: 0.16rem;
    //    }
    //  }
    //  .el-dialog__body {
    //    padding: 0.25rem 0.25rem 0.3rem;
    //    font-size: 0.14rem;
    //    .el-button {
    //      font-size: 0.14rem;
    //      padding: 0.12rem 0.2rem;
    //      border-radius: 0.04rem;
    //    }
    //  }
    //  .el-dialog__footer {
    //    .el-button {
    //      font-size: 0.14rem !important;
    //      padding: 0.12rem 0.2rem !important;
    //      border-radius: 0.04rem !important;
    //    }
    //  }
    //}
  }
/deep/.el-dialog {
  margin: 0 auto 0.5rem;
  border-radius: 0.02rem;
  .el-dialog__header {
    padding: 0.2rem 0.2rem 0.1rem;
    .el-dialog__title {
      font-size: 0.18rem;
      line-height: 0.24rem;
    }
    .el-dialog__headerbtn {
      top: 0.2rem;
      right: 0.2rem;
      font-size: 0.16rem;
    }
  }
  .el-dialog__body {
    padding: 0.25rem 0.25rem 0.3rem;
    font-size: 0.14rem;
    .el-button {
      font-size: 0.14rem;
      padding: 0.12rem 0.2rem;
      border-radius: 0.04rem;
    }
    .lightBox {
      .exportAndImport {
        text-align: -webkit-left;
        height: 1rem;
        .round {
          display: inline-block;
          width: 0.3rem;
          height: 0.3rem;
          line-height: 0.3rem;
          text-align: center;
          border-radius: 50%;
          margin-left: 0.2rem;
        }
        h5 {
          margin-bottom: 0.1rem;
        }
        .import {
          #file-upload-button {
            padding: 0.12rem 0.2rem;
            font-size: 0.14rem;
            border-radius: 0.04rem;
          }
        }
        input[type="file"] {
          display: none; /* 隐藏实际的文件输入 */
        }
      }
    }
  }
  .el-dialog__footer {
    .el-button {
      font-size: 0.14rem !important;
      padding: 0.12rem 0.2rem !important;
      border-radius: 0.04rem !important;
    }
  }
}
</style>
